/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useTranslation } from "react-i18next";

import * as url from "helper/UrlHelper";

// Material UI table
import { MaterialReactTable } from "material-react-table";
import { MenuItem, Box, Tooltip, IconButton } from "@mui/material";
import { createTaskChatHandler } from "helper/TaskHelper/TaskHelper";
import { assetImages } from "constants";

const CurrentRunningTasklist = ({ taskList = [] }) => {
  const { t } = useTranslation();
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  //* Material React Table Column and States */
  const columns = useMemo(
    () => [
      {
        accessorKey: "customid",
        header: t("ID"),
        size: 100,
        // Filter: globalFilterTextHandler,
      },
      {
        accessorKey: "title",
        header: t("Title"),
        size: 200,
        Cell: ({ row }) => (
          <Box className="title border-bottom-0" sx={{ width: "200px" }}>
            <div className="d-flex align-items-center gap-4">
              <Link
                to={`/admin/task/details/${row.original._id}`}
                className="d-flex align-items-center gap-1 fs-md"
              >
                {row.original.title}
              </Link>
            </div>
          </Box>
        ),
      },
      {
        accessorKey: "rank",
        header: t("Rank"),
      },
      {
        accessorKey: "taskstatus",
        header: t("Task Status"),
      },
      {
        accessorKey: "taskpercent",
        header: t("Complete %"),
      },
      {
        accessorKey: "projectname",
        header: t("Project"),
        size: 250,
      },
      {
        accessorKey: "taskpriority",
        header: t("Priority"),
      },
      {
        accessorKey: "hours",
        header: t("Planned Hours"),
      },
      {
        accessorKey: "loggedhours",
        header: t("Dedicated Hours"),
      },
      {
        accessorKey: "balancehours",
        header: t("Balance Hours"),
        Cell: ({ row }) => (
          <div className="ranking border-bottom-0">
            <p
              className={`ps-3 ${
                row.original.balancehours < 0 ? "text-danger" : ""
              }`}
            >
              {row.original.balancehours}
            </p>
          </div>
        ),
        // Filter: globalFilterTextHandler,
      },
      {
        accessorKey: "startdate",
        header: t("Start Date"),
      },
      {
        accessorKey: "enddate",
        header: t("End Date"),
      },
      {
        accessorKey: "tasknumberofdaysleft",
        header: t("Days Left"),
        Cell: ({ row }) => (
          <Box className="title border-bottom-0" sx={{ width: "200px" }}>
            <div className="d-flex align-items-center gap-4">
              <p
                className={
                  row.original.tasknumberofdaysleft <= 3 ? "text-primary" : ""
                }
              >
                {" "}
                {row.original.tasknumberofdaysleft}
              </p>
            </div>
          </Box>
        ),
      },
      {
        accessorKey: "moderatorname",
        header: t("Assigned By"),
        size: 300,
        Cell: ({ row }) => (
          <div className="owner border-bottom-0 d-flex gap-1">
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.moderatorimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.moderatorimage
              }
              alt="Babcock"
            />
            <p>
              <span className="d-block">{row.original.moderatorname}</span>
              <span className="d-block">{row.original.moderatoremail}</span>
            </p>
            <button
              onClick={() => {
                createTaskChatHandler(row.original._id);
              }}
              className={
                row.original.moderator.toString() === userInfo._id.toString()
                  ? "d-none"
                  : "d-flex align-items-center ms-auto border-0 bg-light"
              }
            >
              <span className="d-block material-symbols-outlined icon-md text-primary">
                chat
              </span>
            </button>
          </div>
        ),
        // Filter: globalFilterTextHandler,
      },
      {
        accessorKey: "assignedusername",
        header: t("Assigned To"),
        size: 300,
        Cell: ({ row }) => (
          <div className="owner border-bottom-0 d-flex gap-1">
            {row.original.assignedusername === "" ? null : (
              <img
                className="rounded-circle"
                height={35}
                width={35}
                src={
                  row.original.assigneduserimage == ""
                    ? assetImages.defaultUser
                    : url.SERVER_URL + row.original.assigneduserimage
                }
                alt="Babcock"
              />
            )}
            <p>
              <span className="d-block">{row.original.assignedusername}</span>
              <span className="d-block">{row.original.assigneduseremail}</span>
            </p>
            <button
              onClick={() => {
                createTaskChatHandler(row.original._id);
              }}
              className={
                !row.original.assigneduser ||
                row.original.assigneduser === userInfo._id
                  ? "d-none"
                  : "d-flex align-items-center ms-auto border-0 bg-light"
              }
            >
              <span className="d-block material-symbols-outlined icon-md text-primary">
                chat
              </span>
            </button>
          </div>
        ),
        // Filter: globalFilterTextHandler,
      },
      {
        accessorKey: "followersnames",
        header: t("Followers"),
        size: 250,
        Cell: ({ row }) =>
          row.original.followerslist.map((follower, index) => (
            <div
              className="owner border-bottom-0 d-flex gap-1 mb-1"
              key={index}
            >
              <img
                className="rounded-circle"
                height={15}
                width={15}
                src={
                  follower.image == ""
                    ? assetImages.defaultUser
                    : url.SERVER_URL + follower.image
                }
                alt="Babcock"
              />

              <p>
                <span className="d-block">{follower.fullname}</span>
              </p>
              <button
                onClick={() => {
                  createTaskChatHandler(row.original._id);
                }}
                className={
                  follower._id === userInfo._id
                    ? "d-none"
                    : "d-flex align-items-center ms-auto border-0 bg-light"
                }
              >
                <span className="d-block material-symbols-outlined icon-md text-primary">
                  chat
                </span>
              </button>
            </div>
          )),
      },
      {
        accessorKey: "projectsectionname",
        header: t("Section"),
        size: 200,
      },
      {
        accessorKey: "tasklogupdatedperson",
        header: t("Log Updated By"),
        size: 300,
        Cell: ({ row }) => (
          <div className="owner border-bottom-0 d-flex gap-1">
            {row.original.tasklogupdatedpersonimage == "" ? null : (
              <img
                className="rounded-circle"
                height={35}
                width={35}
                src={url.SERVER_URL + row.original.tasklogupdatedpersonimage}
                alt="Babcock"
              />
            )}
            <p>
              <span className="d-block">
                {row.original.tasklogupdatedpersonname}
              </span>
              <span className="d-block">
                {row.original.tasklogupdatedpersonemail}
              </span>
            </p>
            <button
              onClick={() => {
                createTaskChatHandler(row.original._id);
              }}
              className={
                !row.original.logupdatedby ||
                row.original.logupdatedby === userInfo._id
                  ? "d-none"
                  : "d-flex align-items-center ms-auto border-0 bg-light"
              }
            >
              <span className="d-block material-symbols-outlined icon-md text-primary">
                chat
              </span>
            </button>
          </div>
        ),
      },
      {
        accessorKey: "tasklogupdatedon",
        header: t("Log updated on"),
      },
      {
        accessorKey: "leadtitle",
        header: t("Lead"),
        size: 200,
      },
      {
        accessorKey: "contactname",
        header: t("Contact"),
        size: 200,
      },
      {
        accessorKey: "tagstring",
        header: t("Label"),
        Cell: ({ row }) => (
          <div className="label border-bottom-0">
            {row.original.tagstring != "" && (
              <ul className="d-flex flex-wrap gap-2 fs-xs">
                {row.original.tagstring.split(" , ").map((tag, index) => {
                  return (
                    <li
                      key={index}
                      className="px-2 py-1 gradient-light rounded-5"
                    >
                      {tag}
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
        ),
      },
    ],
    []
  );

  return (
    <div
      className={
        taskList.length === 0
          ? "d-none"
          : "rounded-10 shadow-sm p-3 bg-white mb-4"
      }
    >
      <div className="filter-container py-3">
        <div className="row align-items-center">
          <div className="col-md-5 col-lg-6 d-none d-md-block mb-3 mb-md-0">
            <h3>Ongoing Tasks</h3>
          </div>
          <div className="col-md-7 col-lg-6 d-flex justify-content-end">
            <div className="report_slect_container d-flex justify-content-end w-100  gap-1 gap-sm-2"></div>
          </div>
        </div>
      </div>
      <div className="table-wrapper report_table">
        <div className="table-responsive mb-4">
          <MaterialReactTable
            columns={columns} // map columns to be displayed with api data,
            data={taskList} // data from api to be displayed
            enableGrouping
            // enableRowSelection // enable showing checkbox
            getRowId={(row) => row._id} // map which value to select with row checkbox
            // onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
            // state={{ rowSelection }} //pass our managed row selection state to the table to use
            // enableRowActions // show the action column
            // renderRowActionMenuItems={({ row }) => [
            //   <MenuItem key="view">
            //     <Link
            //       className="dropdown-item"
            //       to={`/admin/projectmanagement/details/${row.id}`}
            //     >
            //       {t("View Details")}
            //     </Link>
            //   </MenuItem>,
            //   <MenuItem key="copy">
            //     <Link
            //       className="dropdown-item"
            //       to={`/admin/projectmanagement/copyproject/${row.id}`}
            //     >
            //       {t("Copy Project")}
            //     </Link>
            //   </MenuItem>,
            //   <MenuItem key="member">
            //     <Link
            //       className="dropdown-item"
            //       to={`/admin/projectmanagement/members/${row.id}`}
            //     >
            //       {t("View Members")}
            //     </Link>
            //   </MenuItem>,
            //   <MenuItem key="task">
            //     <Link
            //       className="dropdown-item"
            //       to={`/admin/projectmanagement/tasksection/${row.id}`}
            //     >
            //       {t("View Task")}
            //     </Link>
            //   </MenuItem>,
            //   <MenuItem key="log">
            //     <Link
            //       className="dropdown-item"
            //       to={`/admin/projectmanagement/logs/${row.id}`}
            //     >
            //       {t("View Logs")}
            //     </Link>
            //   </MenuItem>,
            // ]} // action columns menu items
            defaultColumn={{
              minSize: 20,
              maxSize: 300,
              size: 50, //make columns wider by default
            }}
            muiTableContainerProps={{
              sx: {
                maxHeight: "60vh",
              },
            }}
            enableStickyHeader
          />
        </div>
      </div>
    </div>
  );
};

export default CurrentRunningTasklist;
